module.exports = __webpack_public_path__ + "static/media/purple.97f4e2cb.jpg";